import styled from "styled-components";
import { deviceSizesMin } from "../../../DeviceSizes";

/*
 *
 *   Wraps SiteMenuElement with corresponding SubNav
 *
 */
export const SiteMenuElementWrapper = styled.div`
  @media only screen and ${deviceSizesMin.laptop} {
    position: relative;

    width: auto;
    height: 100%;
    display: inline-flex;
    margin: auto;
  }
`;

export const SiteMenuElement = styled.div`
  position: relative;
  display: flex;
  padding: 0 18px;
  font-weight: bolder;
  letter-spacing: 1.25px;
  line-height: 26px;
  align-items: center;

  text-transform: uppercase;

  border: black solid 2px;
  width: 90%;
  height: 50px;
  margin: 10px auto auto auto;

  @media only screen and ${deviceSizesMin.laptop} {
    position: relative;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    margin: auto;

    font-size: 12px;

    width: 100%;
    height: 100%;

    background: ${(props) => (props.open ? "black" : "white")};
    color: ${(props) => (props.open ? "white" : "black")};

    border: none;
  }

  @media only screen and ${deviceSizesMin.laptopL} {
    font-size: 16px;
  }
`;

export const SiteMenuElementIcon = styled.img`
  width: 20px;
  margin-left: 6px;
  position: absolute;
  right: 10px;

  transform: scaleY(${(props) => (props.active ? -1 : 1)});

  @media only screen and ${deviceSizesMin.laptop} {
    position: relative;
    margin-left: 15px;
    width: 15px;

    -webkit-filter: ${(props) => (props.active ? "invert(100%)" : "none")};
    filter: ${(props) => (props.active ? "invert(100%)" : "none")};
  }
`;
